import type { ParagraphBigVideo as ParagraphBigVideoData } from "@/lib/api/cms-catalog";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { VideoEmbed } from "../shared/VideoEmbed";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layout 11 - `PARAGRAPH_THREE_COLS_BIG_VIDEO_LAYOUT`: duże wideo na pełną szerokość.
 *
 * Nazwa "THREE_COLS" w PHP define jest legacy - w praktyce template renderuje
 * jedno duże video (16:9) na całą szerokość akapitu, opcjonalnie z nagłówkiem.
 */
export function ParagraphBigVideo({
  paragraph,
  t,
}: {
  paragraph: ParagraphBigVideoData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      <VideoEmbed src={paragraph.video} title={paragraph.name} t={t} />
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}
